var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"m-0",attrs:{"no-body":"","border-variant":"white"}},[_c('b-card-body',{staticClass:"pb-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }